import React, { Fragment, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faBuilding,
    faPlus,
    faUser,
    faUserCircle,
    faUserSecret,
} from '@fortawesome/free-solid-svg-icons'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Swal from 'sweetalert2'

import Header from '../Header/Header'
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import { registerTenant } from '../../Services/tenantService'
import { saveError } from '../../Services/errorService'

function AddTenant({ history }) {
    const token = JSON.parse(atob(sessionStorage.getItem('token').split('.')[1]))
    const rol = token.authorities[0]

    useEffect(() => {
        if (rol !== 'ROLE_ADMIN_MAGENTA') {
            history.goBack()
        }
    }, [history, rol])

    const formik = useFormik({
        initialValues: {
            nombreTenant: '',
            nombre: '',
            apellido: '',
            dni: '',
            username: '',
            password: '',
            passwordConfirm: '',
        },
        validationSchema: Yup.object({
            nombreTenant: Yup.string()
                .required('El nombre del tenant es obligatorio')
                .min(2, 'Mínimo 2 caracteres'),
            nombre: Yup.string().required('Obligatorio').min(2),
            apellido: Yup.string().required('Obligatorio').min(2),
            dni: Yup.string()
                .required('Obligatorio')
                .matches(/^\d+$/, 'Solo números'),
            username: Yup.string().required('Obligatorio').min(4),
            password: Yup.string().required('Obligatorio').min(4),
            passwordConfirm: Yup.string()
                .when('password', {
                    is: (val) => (val && val.length > 0 ? true : false),
                    then: Yup.string().oneOf(
                        [Yup.ref('password')],
                        'Las contraseñas no son iguales'
                    ),
                })
                .required('Obligatorio'),
        }),
        onSubmit: (values) => addTenantSubmit(values),
    })

    const addTenantSubmit = (values) => {
        const payload = {
            nombre: values.nombre,
            apellido: values.apellido,
            dni: parseInt(values.dni, 10),
            username: values.username,
            password: values.password,
            nombreTenant: values.nombreTenant,
        }

        registerTenant(payload)
            .then(() => {
                history.push('/backoffice/tenants')
            })
            .catch(async (error) => {
                const errorData = {
                    mensaje: 'Error al intentar registrar un tenant',
                    detalle: error.message,
                    entidad: 'TENANT',
                    tipo: 'WEBAPP',
                    severidad: 'HIGH',
                    reportado: 'APPLICATION',
                }

                await saveError(errorData)
                Swal.fire({
                    text:
                        error.response?.data?.message ||
                        'No se pudo registrar el tenant. Verifique los datos.',
                    icon: 'error',
                    showConfirmButton: true,
                })
            })
    }

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faBuilding} title={'Registrar tenant'} />
                </div>

                <div className="bg-gris p-4">
                    <form onSubmit={formik.handleSubmit}>
                        <div className="form-row">
                            <div className="form-group col-md-12">
                                <label htmlFor="inputNombreTenant">
                                    Nombre del comercio / tenant
                                </label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span
                                            className="input-group-text"
                                            id="inputGroupPrepend"
                                        >
                                            <FontAwesomeIcon icon={faBuilding} />
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        id="inputNombreTenant"
                                        name="nombreTenant"
                                        className="form-control"
                                        placeholder="Ej. SANGUCHERIA MAGENTA"
                                        value={formik.values.nombreTenant}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {formik.touched.nombreTenant &&
                                formik.errors.nombreTenant ? (
                                    <small className="form-text text-danger">
                                        {formik.errors.nombreTenant}
                                    </small>
                                ) : null}
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group col-md-6">
                                <label htmlFor="inputNombre">Nombre (admin)</label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span
                                            className="input-group-text"
                                            id="inputGroupPrepend"
                                        >
                                            <FontAwesomeIcon icon={faUser} />
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        id="inputNombre"
                                        name="nombre"
                                        className="form-control"
                                        placeholder="Nombre"
                                        value={formik.values.nombre}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {formik.touched.nombre && formik.errors.nombre ? (
                                    <small className="form-text text-danger">
                                        {formik.errors.nombre}
                                    </small>
                                ) : null}
                            </div>

                            <div className="form-group col-md-6">
                                <label htmlFor="inputApellido">Apellido</label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span
                                            className="input-group-text"
                                            id="inputGroupPrepend"
                                        >
                                            <FontAwesomeIcon icon={faUser} />
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        id="inputApellido"
                                        name="apellido"
                                        className="form-control"
                                        placeholder="Apellido"
                                        value={formik.values.apellido}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {formik.touched.apellido &&
                                formik.errors.apellido ? (
                                    <small className="form-text text-danger">
                                        {formik.errors.apellido}
                                    </small>
                                ) : null}
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group col-md-6">
                                <label htmlFor="inputDni">DNI</label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span
                                            className="input-group-text"
                                            id="inputGroupPrepend"
                                        >
                                            <FontAwesomeIcon icon={faUser} />
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        id="inputDni"
                                        name="dni"
                                        className="form-control"
                                        placeholder="Sin puntos"
                                        value={formik.values.dni}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {formik.touched.dni && formik.errors.dni ? (
                                    <small className="form-text text-danger">
                                        {formik.errors.dni}
                                    </small>
                                ) : null}
                            </div>

                            <div className="form-group col-md-6">
                                <label htmlFor="inputUsername">
                                    Nombre de usuario
                                </label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span
                                            className="input-group-text"
                                            id="inputGroupPrepend"
                                        >
                                            <FontAwesomeIcon icon={faUserCircle} />
                                        </span>
                                    </div>
                                    <input
                                        type="text"
                                        id="inputUsername"
                                        name="username"
                                        className="form-control"
                                        autoComplete="username"
                                        value={formik.values.username}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {formik.touched.username &&
                                formik.errors.username ? (
                                    <small className="form-text text-danger">
                                        {formik.errors.username}
                                    </small>
                                ) : null}
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group col-md-6">
                                <label htmlFor="inputPass">Contraseña</label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span
                                            className="input-group-text"
                                            id="inputGroupPrepend"
                                        >
                                            <FontAwesomeIcon icon={faUserSecret} />
                                        </span>
                                    </div>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="inputPass"
                                        name="password"
                                        placeholder="********"
                                        autoComplete="new-password"
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {formik.touched.password &&
                                formik.errors.password ? (
                                    <small className="form-text text-danger">
                                        {formik.errors.password}
                                    </small>
                                ) : null}
                            </div>

                            <div className="form-group col-md-6">
                                <label htmlFor="inputPassConfirm">
                                    Confirmar contraseña
                                </label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span
                                            className="input-group-text"
                                            id="inputGroupPrepend"
                                        >
                                            <FontAwesomeIcon icon={faUserSecret} />
                                        </span>
                                    </div>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="inputPasswordConfirm"
                                        name="passwordConfirm"
                                        placeholder="********"
                                        autoComplete="new-password"
                                        value={formik.values.passwordConfirm}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {formik.touched.passwordConfirm &&
                                formik.errors.passwordConfirm ? (
                                    <small className="form-text text-danger">
                                        {formik.errors.passwordConfirm}
                                    </small>
                                ) : null}
                            </div>
                        </div>

                        <div className="text-center">
                            <button
                                type="submit"
                                className="btn btn-outline-success"
                            >
                                <FontAwesomeIcon icon={faPlus} /> Registrar
                                tenant
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(AddTenant)
